import React, {Component} from 'react';
import './pageCss/Labs.css';
import VimoMenyL from '../components/LabsProjects/VimoMenyL' 

 export class Labs extends Component {

   render(){ 
  return (
    <div class="Labs-section-1">
            <div>
            <h3 class="hs2-recent-tit"> Code </h3>
                <VimoMenyL/>
            </div>
            <div>
                <h3 class="hs2-recent-tit"> Design</h3>
                <img src={process.env.PUBLIC_URL + "/images/Projects/Labs/ChrisUi.png"} class="pws1-poke-imgs" />
            </div>
    </div>
  );
}
}


export default Labs;
